import React from "react";

import { faDownload } from "@fortawesome/pro-solid-svg-icons/faDownload";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tooltip from "antd/es/tooltip";
import { useIntl } from "react-intl";

import useBoolean from "@mapmycustomers/shared/util/hook/useBoolean";
import { Button } from "@mapmycustomers/ui";

import DownloadEntitiesModal, { DownloadEntitiesProps } from "./index";

interface Props extends Omit<DownloadEntitiesProps, "onHide" | "visible"> {}

const DownloadEntitiesButton: React.FC<Props> = (props) => {
  const intl = useIntl();
  const [visible, show, hide] = useBoolean();

  return (
    <>
      <Tooltip
        placement="top"
        title={intl.formatMessage({
          id: "downloadEntities.modal.button.tooltip",
          defaultMessage: "Download",
          description: "Download entities modal - button - download tooltip",
        })}
      >
        <Button icon={<FontAwesomeIcon icon={faDownload} />} iconOnly onClick={show} type="text" />
      </Tooltip>
      {visible && <DownloadEntitiesModal {...props} onHide={hide} />}
    </>
  );
};

export default DownloadEntitiesButton;
